import { emplaceMap, isObject } from './util.js';
export var ReadonlyProxy;
(function (ReadonlyProxy) {
    function create(obj) {
        return new Proxy(obj, new ReadonlyProxyHandler());
    }
    ReadonlyProxy.create = create;
})(ReadonlyProxy || (ReadonlyProxy = {}));
class ReadonlyProxyHandler {
    map = new Map();
    get(target, p, receiver) {
        const value = Reflect.get(target, p, receiver);
        if (p !== 'prototype' && isObject(value)) {
            return emplaceMap(this.map, p, { insert: () => ReadonlyProxy.create(value) });
        }
        return value;
    }
    set(_target, p, _value, _receiver) {
        throw new TypeError(`Cannot set property '${String(p)}' on a readonly proxy`);
    }
    deleteProperty(_target, p) {
        throw new TypeError(`Cannot delete property '${String(p)}' on a readonly proxy`);
    }
}
//# sourceMappingURL=ReadonlyProxy.js.map